import { POST } from 'dealer-sagas/src/consts/methods'
import apiCall from '../apiCall'

interface PickUpParams {
  offerId: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const confirmPickUp = async ({ offerId }: PickUpParams): Promise<any> => {
  const endpoint = '/api/v2/invoices'
  const params = { offer_id: offerId }
  return await apiCall({ endpoint, params, method: POST })
}
